import AdminAgrupacionCentrosForm from './AgrupacionCentrosForm.vue';
import BotoneraLoginAs from './BotoneraLoginAs.vue';

export default {
  install: (app, _options) => {
    app
      .component('AdminAgrupacionCentrosForm', AdminAgrupacionCentrosForm)
      .component('BotoneraLoginAs', BotoneraLoginAs);
  },
};
